var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00059 10.4016C9.32607 10.4016 10.4006 9.32705 10.4006 8.00156C10.4006 6.67608 9.32607 5.60156 8.00059 5.60156C6.6751 5.60156 5.60059 6.67608 5.60059 8.00156C5.60059 9.32705 6.6751 10.4016 8.00059 10.4016Z",
    fill: "#14AE5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.2H14.3448C14.1651 5.79237 13.5231 4.48425 12.5195 3.48098C11.516 2.47771 10.2077 1.83607 8.8 1.6568V0H7.2V1.6568C5.79237 1.83621 4.48414 2.47788 3.4806 3.48113C2.47706 4.48438 1.83501 5.79242 1.6552 7.2H0V8.8H1.6552C1.83435 10.2082 2.47611 11.5169 3.47971 12.5208C4.48331 13.5247 5.7919 14.1668 7.2 14.3464V16H8.8V14.3464C10.2081 14.1668 11.5167 13.5247 12.5203 12.5208C13.5239 11.5169 14.1656 10.2082 14.3448 8.8H16V7.2ZM8 12.8C7.05065 12.8 6.12262 12.5185 5.33326 11.9911C4.54391 11.4636 3.92868 10.714 3.56538 9.83688C3.20208 8.9598 3.10702 7.99468 3.29223 7.06357C3.47744 6.13246 3.9346 5.27718 4.60589 4.60589C5.27718 3.9346 6.13246 3.47744 7.06357 3.29223C7.99468 3.10702 8.9598 3.20208 9.83688 3.56538C10.714 3.92868 11.4636 4.54391 11.9911 5.33326C12.5185 6.12262 12.8 7.05065 12.8 8C12.7985 9.27258 12.2923 10.4926 11.3925 11.3925C10.4926 12.2923 9.27258 12.7985 8 12.8Z",
    fill: "#14AE5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoc);
export default __webpack_public_path__ + "static/media/loc.474a2188bc66a391df9ccd73b649c8b1.svg";
export { ForwardRef as ReactComponent };